import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import { AsOfDate } from './AsOfDate';

export const PercentageFormatter = ({ record, field }) => {
  const { value, asOfDate } = record[field];

  const displayText = useMemo(() => parseFloat(value.toFixed(4)), [value]);

  return (
    <>
      <Typography>{`${displayText}%`}</Typography>
      <AsOfDate date={asOfDate} />
    </>
  );
};

PercentageFormatter.propTypes = {
  record: PropTypes.object.isRequired,
  field: PropTypes.string.isRequired
};

export default PercentageFormatter;
